document.addEventListener("DOMContentLoaded", function () {
  const counters = document.querySelectorAll(".counter");

  const runCounter = (counter) => {
    const target = +counter.getAttribute("data-target");
    let count = 0;

    const duration = 1500; 
    const stepTime = Math.abs(Math.floor(duration / target));

    const timer = setInterval(() => {
      count++;
      counter.innerText = count;

      if (count >= target) {
        counter.innerText = target;
        clearInterval(timer);
      }
    }, stepTime);
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        runCounter(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.5 });

  counters.forEach(counter => {
    observer.observe(counter);
  });
});